fx.ns("desktop.book.edition", class PhotoChoicesIA extends desktop.common.photoimport.PhotoChoices {
    
	constructor()
	{
		super({mobile : true, computer : true, google : false, file:false, albums : false });

		this.showBack = true;
        this.showNext = false;
        this.mode = ""; // empty, so no button displayed from PopupPanel

        this.bottomText = fx.text("Sélectionnez au minimum une trentaine de photos");
        this.containerHeight = 550;
	}

	
    // override
    /*onFilesSelected()
	{
        // we do nothing 
	}*/

    // override
	onBack()
	{
		this.data.event("previous-step");
	}


});